import appQr from '../../assets/Ourapp/appQr.png'
import arrowDarkLeft from '../../assets/icons/arrow_dark_left-lg.svg'

const features = [
  {
    title: 'Duty of Confidence',
    description:
      'We include a contractual duty of confidence to keep your issue confidential.',
  },
  {
    title: '256-bit TLS encryption',
    description:
      'All data, regardless of sensitivity, is encrypted at transit, rest, and storage.',
  },
  {
    title: 'Cyber-Threat Monitoring',
    description:
      'We employ the technologies to continuously monitor systems cyber-security.',
  },
]

const EncryptionInfo = () => {
  return (
    <div className='w-full flex flex-col gap-8 lg:gap-12 2xl:gap-40 relative'>
      <div className='w-full flex flex-col items-center gap-6 lg:flex-row lg:justify-between lg:px-10 2xl:px-20'>
        <div className='hidden lg:flex items-center gap-3'>
          <div className='w-[67px] h-[69.93px] flex-shrink-0 rounded-[5px] border border-black bg-white flex items-center justify-center'>
            <img src={appQr} className='w-[49.834px] h-[52.013px] ' />
          </div>

          <div className='flex flex-col items-start gap-1'>
            <p className='text-black text-lg font-bold leading-8 tracking-wide'>
              Available on iOS
            </p>
            <p className='text-black  text-sm font-medium leading-normal'>
              Scan to Download for free
            </p>
          </div>
        </div>
        <div className='flex flex-col items-center lg:items-end gap-[24px] lg:gap-[35px]'>
          <h2 className='text-2xl font-bold leading-8 tracking-wide text-[#093269] text-center lg:leading-normal lg:text-4xl 3xl:text-[64px] lg:text-right'>
            Encrypted <br /> Confidential Private
          </h2>
          <div>
            <p className='text-[#122D5C] text-sm font-medium leading-normal text-center lg:text-lg lg:font-bold lg:leading-8 lg:tracking-wide lg:text-right'>
              Your issue is our obligation to confidence. <br />
              Legal Utopia keeps your words encrypted, in the UK and secure.
            </p>
          </div>
        </div>
      </div>
      <div className='flex flex-col items-start gap-10 self-stretch  lg:flex-row  lg:gap-12 2xl:gap-15 lg:w-full lg:px-20'>
        {features.map((feature, index) => (
          <div
            key={index}
            className='flex items-start gap-[14px] self-stretch lg:self-auto'
          >
            <div>
              <img src={arrowDarkLeft} className='h-4 w-4 lg:h-6 lg:w-6' />
            </div>
            <div className='flex flex-col gap-3'>
              <h5 className='text-[#001A3D] text-sm font-medium leading-normal lg:text-xl  2xl:text-2xl lg:font-bold 2xl:leading-8 lg:tracking-wide'>
                {feature.title}
              </h5>
              <p className='text-[#37455C]  text-xs font-normal leading-4 tracking-wide lg:text-sm 2xl:text-base lg:font-medium lg:leading-6'>
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div
        className='w-[300px] h-[296px] flex-shrink-0 absolute top-[300px] right-0   lg:top-0
        lg:w-[601.6px] lg:h-[477.5px] xl:w-[752px] xl:h-[596.8px] 2xl:w-[902.4px] 2xl:h-[716.5px]
        3xl:w-[1128px] 3xl:h-[895px] '
      >
        <div className='relative w-full h-full'>
          <div
            className='w-[200px] h-[200px] flex-shrink-0 bg-[#9ABDEC] blur-[50px] absolute top-0 left-0 -z-10 
            lg:w-[373.33px] lg:h-[373.33px] lg:rounded-[373.33px] lg:blur-[80px] 
            xl:w-[466.67px] xl:h-[466.67px] xl:rounded-[466.67px]  xl:blur-[100px]
            2xl:w-[560px] 2xl:h-[560px] 2xl:rounded-[560px] 2xl:blur-[120px] 
            3xl:w-[700px] 3xl:h-[700px]  3xl:rounded-[700px] 3xl:blur-[150px]
          '
          ></div>
        </div>

        <div
          className='w-[200px] h-[200px] flex-shrink-0 bg-[#BBD2D7] blur-[50px] absolute bottom-0 right-0 -z-20 
          lg:w-[373.33px] lg:h-[373.33px] lg:rounded-[373.33px] lg:blur-[80px] lg:top-[104px] lg:bottom-auto 
          xl:w-[466.67px] xl:h-[466.67px] xl:rounded-[466.67px] xl:blur-[100px] xl:top-[130px]
          2xl:w-[560px] 2xl:h-[560px] 2xl:rounded-[560px] 2xl:blur-[120px] 2xl:top-[156px] 
          3xl:w-[700px] 3xl:h-[700px] 3xl:rounded-[700px] 3xl:blur-[150px] 3xl:top-[195px]'
        ></div>
      </div>
    </div>
  )
}
export default EncryptionInfo
